import { render, staticRenderFns } from "./CobranzaShowDataCustom.vue?vue&type=template&id=55b4551d"
import script from "./CobranzaShowDataCustom.vue?vue&type=script&lang=js"
export * from "./CobranzaShowDataCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports